import React from 'react'
import ReactDOM from 'react-dom'

const Portal = ({ children }) =>
  !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  ) ? (
    ReactDOM.createPortal(children, document.body)
  ) : (
    <>{children}</>
  )

export default Portal
